import React from 'react';
import { IOrderDetailLine, IOrderDetailScheduleLine } from '../../../actions/order-details/get-order-details.action';
import DataTitle from '../../../components/data-title';
import { NO_DATA_FALLBACK } from '../../../configuration';
import { ILocalizationState } from '../../../states/localization-state';
import {
    checkIfValidNumber,
    dateLocaleFormatter,
    formatNumberLocaleStatic,
    mapItemStatusCodeDescriptionToText,
    mapItemStatusCodeToText,
    toLocalDate
} from '../../../utilities';
import { IOrderDetailsResources } from '../order-details.props.autogenerated';

interface ExpandedRowsProps {
    item: IOrderDetailLine;
    resources: IOrderDetailsResources;
    localizationState: ILocalizationState;
    isExpanded: boolean;
    CLASS_NAME: string;
}

interface StatusDefinition {
    status: string;
    statusId: string;
    date?: string | undefined;
    qty?: number | string | undefined;
    unit?: string | undefined;
}

//TODO
const CONFIRMED_STATE = '30';
const REQUESTED_STATE = '10';

export const getFirstLine = (item: IOrderDetailLine): IOrderDetailScheduleLine | undefined => {
    return item.ScheduleLines && item.ScheduleLines?.length ? item.ScheduleLines[0] : undefined;
};

const shouldShowRow = (row: StatusDefinition) => checkIfValidNumber(row.qty) || !!row.date;

export const ExpandedRows: React.FC<ExpandedRowsProps> = ({ item, resources, localizationState, isExpanded, CLASS_NAME }) => {
    if (!isExpanded) {
        return null;
    }

    const firstLine = getFirstLine(item);
    const currentStatusText = mapItemStatusCodeToText(item.StateLogistics, resources);

    const statusDefinitions: StatusDefinition[] = [
        {
            status: resources.globalStatusItemConfirmed,
            statusId: CONFIRMED_STATE,
            date: firstLine?.ConfirmedDate,
            qty: firstLine?.ConfirmedQty,
            unit: firstLine?.ConfirmedUnit
        },
        {
            status: resources.globalStatusItemRequested,
            statusId: REQUESTED_STATE,
            date: item.RequestedDate,
            qty: item.RequestedQty,
            unit: item.RequestedUnit
        }
    ];

    return (
        <>
            {statusDefinitions
                .filter((row: StatusDefinition) => shouldShowRow(row)) // Check for valid values
                .filter((status: StatusDefinition) => status.status !== currentStatusText) // Do not display the current status
                .map((status: StatusDefinition, index: number) => {
                    return (
                        <tr key={index} className={`${CLASS_NAME}-row`}>
                            <td className={`${CLASS_NAME}-cell`} />
                            <td className={`${CLASS_NAME}-cell`} />
                            <td className={`${CLASS_NAME}-cell`} />
                            <td className={`${CLASS_NAME}-cell`}>
                                <div className={`${CLASS_NAME}-status-content`}>
                                    <DataTitle
                                        label={status.status}
                                        title={mapItemStatusCodeDescriptionToText(status.statusId, resources)}
                                    />
                                </div>
                            </td>
                            <td className={`${CLASS_NAME}-cell`}>
                                <div className={`${CLASS_NAME}-date-content`}>
                                    <span>
                                        {status.date
                                            ? dateLocaleFormatter(localizationState).formatDate(toLocalDate(status.date))
                                            : NO_DATA_FALLBACK}
                                    </span>
                                </div>
                            </td>
                            <td className={`${CLASS_NAME}-cell`}>
                                <div className={`${CLASS_NAME}-qty-content`}>
                                    <span>
                                        {status.qty && checkIfValidNumber(status.qty)
                                            ? `${formatNumberLocaleStatic(status.qty, localizationState)} ${status.unit ?? ''}`
                                            : NO_DATA_FALLBACK}
                                    </span>
                                </div>
                            </td>
                            <td className={`${CLASS_NAME}-cell`} />
                            <td className={`${CLASS_NAME}-cell`} />
                            <td className={`${CLASS_NAME}-cell`} />
                            <td className={`${CLASS_NAME}-cell`} />
                            <td className={`${CLASS_NAME}-cell`} />
                        </tr>
                    );
                })}
        </>
    );
};
